import { Button, Stack } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import { resolveObjPathString } from "src/utils/resolve-path";
import { Link as RouteLink, useParams } from "react-router-dom";
import type { BaseItem, FetchAction } from "src/components/template/types";

const OptInButton = styled(Button)`
    font-size: 12px;
    z-index: 10;
    text-align: center;
    padding-right: 12px;
`;

const NoOptInPlaceholder = ({
    data,
    optInFeature,
    children,
}: {
    data: FetchAction["data"];
    optInFeature: BaseItem["optInFeature"];
    children?: React.ReactNode;
}) => {
    const { teamId } = useParams();
    if (!optInFeature) return children || null;
    const optedIn = resolveObjPathString(data, optInFeature.optedInProperty);
    if (optedIn !== false) return children || null;
    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{ height: "100%" }}
        >
            <OptInButton
                as={RouteLink}
                to={teamId ? `/teams/${teamId}/indexes-settings` : `/indexes-settings`}
                variant="contained"
                color="primary"
                fullWidth
                style={{
                    textDecoration: "auto",
                    textAlign: "center",
                }}
            >
                Configure & Enable
            </OptInButton>
            <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                You have not enabled indexes{teamId && " for this team"}.
            </span>
        </Stack>
    );
};

export default NoOptInPlaceholder;
